// extracted by mini-css-extract-plugin
export default {"innholdsfortegnelse":"NeutDt0C71fod_Xp2Oo2","innholdsfortegnelseItem":"sK8uwMr3VZTL1Qdhho9g"};